import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { postVirtualNumber } from '../../../../api/virtual-number/mutations/postVirtualNumber';

interface IPostVirtualNumberParams {
  productId: string;
  productCode: string;
  realNumber: string;
}

interface IPostVirtualNumberResponse {
  virtualNumber: string;
}

interface IUsePostVirtualNumberMutationParams {
  options?: UseMutationOptions<IPostVirtualNumberResponse, AxiosError, IPostVirtualNumberParams>;
}

export const usePostVirtualNumberMutation = ({ options }: IUsePostVirtualNumberMutationParams = {}) => {
  return useMutation<IPostVirtualNumberResponse, AxiosError, IPostVirtualNumberParams>(
    (params) => postVirtualNumber(params),
    options,
  );
};
